module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/File-ad590cdc71aaefe6664eb49bc0363e4d.svg";